import { Component } from '@angular/core';
import { MEDIA_MENTIONS } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-media',
  templateUrl: './landing-media.component.html',
  styleUrls: ['./landing-media.component.scss'],
})
export class LandingMediaComponent {
  readonly mentions = MEDIA_MENTIONS;
}
